angular.module('internal.parkingarea',[])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('internal.parkingarea', {
            url: '/parkingarea',
            views: {
                'content': {
                    templateUrl: 'js/internal/parkingarea/parkingarea.view.html',
                    controller:'ParkingAreaCtrl'
                }
            }
        });
    }]);